import { useDeviceType } from '@cian/ui-kit';
import { SolveProblems } from 'shared/components/SolveProblems';
import { PointsContainer } from '../PointsContainer';
import { AccordionContainer } from '../AccordionContainer';
import { POINTS } from 'shared/constants/points';

export const SolveProblemsContainer: React.FC = () => {
  const device = useDeviceType();

  return (
    <SolveProblems device={device} points={<PointsContainer />} accordion={<AccordionContainer items={POINTS} />} />
  );
};
